import {useCache} from './use_cache'

export const useGroupedColumn = ({tableName}) => {
	return useCache({tableName}).grouped
}
